import { ChevronDown, ChevronUp } from '@good/icons';
import { ActionIcon, Center, Group, Table as MantineTable, Popover, rem, UnstyledButton } from '@mantine/core';
import { forwardRef } from 'react';
import classes from './table-th.module.css';
export const GoodTableTh = forwardRef(({ sticky, children, direction, onSort, options, ...props }, ref) => {
    if (sticky !== undefined) {
        const { placement = 'left', noShadow = false, offset = 0 } = typeof sticky === 'boolean' ? {} : sticky;
        return (<MantineTable.Th ref={ref} pos='sticky' left={placement === 'left' ? offset : undefined} right={placement === 'right' ? offset : undefined} {...props} p={onSort ? 0 : props.p} className={['stickyTh', !noShadow && 'stickyTh__scrollShadow', props.className].filter(Boolean).join(' ')} style={{
                zIndex: 2,
                ...props.style,
            }} bg={props.bg ?? 'var(--mantine-color-body)'} fw={600} fz='sm' tt='uppercase'>
          <ThSortWrapper direction={direction} onSort={onSort}>
            <Group justify='space-between'>
              {children}
              {options && (<Popover>
                  <Popover.Target>
                    <ActionIcon>
                      <ChevronDown />
                    </ActionIcon>
                  </Popover.Target>
                  <Popover.Dropdown>{options}</Popover.Dropdown>
                </Popover>)}
            </Group>
          </ThSortWrapper>
        </MantineTable.Th>);
    }
    return (<MantineTable.Th ref={ref} {...props} p={onSort ? 0 : props.p} bg={props.bg ?? 'var(--mantine-color-body)'} fw={600} fz='sm' tt='uppercase'>
        <Group justify='space-between' align='center' wrap='nowrap'>
          <ThSortWrapper direction={direction} onSort={onSort}>
            {children}
          </ThSortWrapper>
          {options && (<Popover>
              <Popover.Target>
                <ActionIcon variant='default' mr='md' size='sm' c='gray' fz={12}>
                  <ChevronDown />
                </ActionIcon>
              </Popover.Target>
              <Popover.Dropdown>{options}</Popover.Dropdown>
            </Popover>)}
        </Group>
      </MantineTable.Th>);
});
export const ThSortWrapper = ({ direction, onSort, children }) => {
    if (!direction && !onSort) {
        return <>{children}</>;
    }
    const Icon = {
        asc: <ChevronUp />,
        desc: <ChevronDown />,
    }[direction?.toString() ?? ''] ?? <ChevronDown />;
    return (<UnstyledButton onClick={onSort} fz='inherit' fw='inherit' tt='inherit' w='100%' data-sort={direction ? direction : 'false'} className={classes.control} style={{
            padding: 'var(--table-vertical-spacing) var(--table-horizontal-spacing, var(--mantine-spacing-xs))',
        }}>
      <Group wrap='nowrap' gap={4}>
        {children}
        <Center w={rem(21)} h={rem(21)} opacity={0.6}>
          {Icon}
        </Center>
      </Group>
    </UnstyledButton>);
};
